import { IconProps, NocIconGenerator } from '../common';

export const ArrowLeft3 = (props: IconProps): JSX.Element => (
    <NocIconGenerator
        {...props}
        createIconProps={{
            displayName: 'ArrowLeft3',
            path: (
                <path
                    d="M10.6546 12L16.5 18.3L14.9227 20L7.5 12L14.9227 4L16.5 5.7L10.6546 12Z"
                    fill="#212121"
                />
            ),
        }}
    />
);
